import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import type { ReactNode } from 'react';

/**
 * Google's published always-passing v3 test key.
 *
 * Safe default so local dev and CI do not need real credentials; the
 * founder-supplied key overrides it via ``VITE_RECAPTCHA_SITE_KEY``.
 */
const RECAPTCHA_TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

type RecaptchaProviderProps = {
  children: ReactNode;
};

/**
 * Scope reCAPTCHA v3 to routes that submit captcha-gated forms.
 *
 * Wrapping the whole app loads Google scripts on every page (including the
 * homepage LCP path). Only Contact and Estimator need ``executeRecaptcha``.
 *
 * @param props - Provider props.
 * @param props.children - Route subtree that calls ``useGoogleReCaptcha``.
 * @returns Provider wrapping ``children``.
 */
export default function RecaptchaProvider({ children }: RecaptchaProviderProps) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || RECAPTCHA_TEST_SITE_KEY}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
